import React, { memo } from 'react';
import { Ellipse } from '@yme/assets/icons';
import { SVGIcon, ICON_SIZE } from '@yme/atoms/svg-icon';
import { LIGHT_TYPE } from '@yme/tokens/colorSchema';
import { buildKey } from '@yme/utils/common';
import { DEFAULT_VISIBLE_ITEMS } from './constants';
import { DotsStyled, SVGIconStyled, SVGIconInfinityStyled } from './styled';
import { useRangeDots } from './useRangeDots';
function DotsComponent({ counts, activeItem, isRightToLeft, visibleItems = DEFAULT_VISIBLE_ITEMS, theme = LIGHT_TYPE, isDotsFixed = false, }) {
    const isLightTheme = theme === LIGHT_TYPE;
    const { dots, rangeDotsVisible, isLeftInfinityIconVisible, isRightInfinityIconVisible } = useRangeDots({
        counts,
        activeItem,
        visibleItems,
    });
    return (React.createElement(DotsStyled, null,
        React.createElement(SVGIconInfinityStyled, { isDotsFixed: isDotsFixed, isLightTheme: isLightTheme, isRightToLeft: isRightToLeft, isVisibleItem: isLeftInfinityIconVisible, isIconInfinity: true, isPositionStart: !isRightToLeft },
            React.createElement(SVGIcon, { type: Ellipse, size: ICON_SIZE.xxxxs })),
        dots.map((item) => {
            const isCurrentItem = activeItem === item;
            const isVisibleItem = item >= rangeDotsVisible.x1 && item <= rangeDotsVisible.x2;
            return (React.createElement(SVGIconStyled, { key: buildKey('item-dot', item), isActive: isCurrentItem, isLightTheme: isLightTheme, isRightToLeft: isRightToLeft, isVisibleItem: isVisibleItem },
                React.createElement(SVGIcon, { type: Ellipse, size: ICON_SIZE.xxxs })));
        }),
        React.createElement(SVGIconInfinityStyled, { isDotsFixed: isDotsFixed, isLightTheme: isLightTheme, isRightToLeft: isRightToLeft, isVisibleItem: isRightInfinityIconVisible, isIconInfinity: true, isPositionStart: isRightToLeft },
            React.createElement(SVGIcon, { type: Ellipse, size: ICON_SIZE.xxxxs }))));
}
export const Dots = memo(DotsComponent);
Dots.displayName = 'Dots_Component';
